import React, { FC, useContext } from 'react';

import { TimeOutInput } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './Booking.module.scss';
export const Booking: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('booking');
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <div className={s.container}>
      {/*<Toggle*/}
      {/*  label={t('settings.billing.seance.intersection.title')}*/}
      {/*  description={t('settings.billing.seance.intersection.description')}*/}
      {/*  value={settings.bookingStrictMode}*/}
      {/*  onChange={(value: boolean) =>*/}
      {/*    setSetting({*/}
      {/*      alias: ESettingsAliases.BOOKING_STRICT_MODE,*/}
      {/*      value: value ? '1' : '0',*/}
      {/*    })*/}
      {/*  }*/}
      {/*  variant="secondary"*/}
      {/*  emptyBg*/}
      {/*  disabled={!isAvailable}*/}
      {/*  rightContent={!isAvailable ? <SettingsLock /> : undefined}*/}
      {/*  className={s.toggle}*/}
      {/*/>*/}
      {/*<Separator />*/}
      <TimeOutInput
        label={t('setting.booking.headroom')}
        description={t('settings.billing.seance.time_out.description')}
        setting={settings.bookingStrictModeHeadroom}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.BOOKING_STRICT_MODE_HEADROOM}
        inMinutes
        minMinutes={0}
        disabled={isAvailable}
        isAvailable={isAvailable}
        zero={true}
      />
    </div>
  );
};
